import { ReactComponent as ImageCreateSvg } from "../../assets/images/svgs/imageCreate.svg";

const ImageCreateIcon = ({ className = "", ...props }) => {
  return (
    <ImageCreateSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default ImageCreateIcon;
